const COUNT_MODE_OPTIONS = [
  { value: 'Interactions', label: 'Interactions' },
  { value: 'Touchpoints', label: 'Touchpoints' },
];

const BREAKDOWN_OPTIONS = [
  { value: 'InteractionType', label: 'by type', filterField: 'interactionType' },
  { value: 'AssociatedUserIds', label: 'by teammate', filterField: 'associatedUserIds' },
  { value: 'InitiatedByOrganisation', label: 'by initiator', filterField: 'initiator' },
  { value: 'Tags', label: 'by tag', filterField: 'tags' },
];

// interactionType is indexed lowercase in Elasticsearch ("email", "phone call", ...); this maps the
// raw bucket key back to the display label used everywhere else in the product.
const TYPE_DISPLAY_LABELS = {
  email: 'Email',
  meeting: 'Meeting',
  'phone call': 'Phone call',
  'social media': 'Social media',
  events: 'Event',
  other: 'Other',
};

// `bucket` is whatever Elasticsearch returned as the terms-aggregation key: a lowercase interaction
// type string, a numeric user id (as a string), "Agency"/"Team"/"Stakeholder", or a raw tag string.
const resolveBreakdownLabel = ({ breakdownBy, bucket, teamMembers, teamName, agencyName }) => {
  if (breakdownBy === 'InteractionType') {
    return TYPE_DISPLAY_LABELS[bucket?.toLowerCase()] ?? bucket;
  }
  if (breakdownBy === 'AssociatedUserIds') {
    const member = teamMembers?.find((item) => `${item.id}` === `${bucket}`);
    return member?.fullName ?? bucket;
  }
  if (breakdownBy === 'InitiatedByOrganisation') {
    if (bucket === 'Agency') return agencyName ?? 'Agency';
    if (bucket === 'Stakeholder') return 'Stakeholder';
    return teamName ?? 'Us';
  }
  return bucket;
};

const sumSeries = (series) => (series.datapoints ?? []).reduce((total, point) => total + (point.value ?? 0), 0);

const sortBreakdownByQuantity = (breakdown) => [...(breakdown ?? [])].sort((a, b) => sumSeries(b) - sumSeries(a));

export { COUNT_MODE_OPTIONS, BREAKDOWN_OPTIONS, resolveBreakdownLabel, sortBreakdownByQuantity };
